import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import { StyleColor } from '../../utils/styles-constants';

const PopupWrapper = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 30px 40px;
`;

const StyledIcon = styled('div')`
	> svg {
		height: 24px;
		width: 24px;
	}
	margin-bottom: 13px;
`;

const NoSaveAsInfo = styled(Translate)`
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 18px;
	color: ${StyleColor.Black};
`;

export { PopupWrapper, StyledIcon, NoSaveAsInfo };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NoSaveAsPopup/styles.ts